export const getMaxYValue = ( isPercent, maxValue, has100Ceiling ) => {

    // need to maintain output chart height between any range of percentages and 1000s of $
    // i've found some nice limits here that always give us the correct height
    let yMax = isPercent ? 20 : 25000;

    if ( isPercent ) {

        if ( maxValue > 0 && maxValue <= 4.5 ) yMax = 5;
        else if ( maxValue > 4.5 && maxValue <= 9.5 ) yMax = 10;
        else if ( maxValue > 9.5 && maxValue <= 22.5 ) yMax = 25;
        else if ( maxValue > 18 && maxValue <= 50 ) yMax = 60;
        else if ( maxValue > 50 && maxValue <= 100 ) yMax = 100;
        else if ( maxValue > 100 && maxValue <= 140 ) yMax = 150;
        else if ( maxValue > 140 ) yMax += Math.floor( maxValue );

    }
    else {

        if ( maxValue > 0 && maxValue <= 9500 ) yMax = 10000;
        if ( maxValue > 95000 && maxValue <= 22000 ) yMax = 25000;
        else if ( maxValue > 22000 && maxValue <= 45000 ) yMax = 50000;
        else if ( maxValue > 45000 && maxValue <= 70000 ) yMax = 80000;
        else if ( maxValue > 70000 && maxValue <= 95000 ) yMax = 100000;
        else if ( has100Ceiling ) yMax = 100000;
        else if ( maxValue > 95000 && maxValue <= 115000 ) yMax = 120000;
        else if ( maxValue > 115000 && maxValue <= 137500 ) yMax = 140000;
        else if ( maxValue > 137500 && maxValue <= 157500 ) yMax = 160000;
        else if ( maxValue > 157500 && maxValue <= 190000 ) yMax = 200000;
        else if ( maxValue > 190000 && maxValue <= 280000 ) yMax = 300000;
        else if ( maxValue > 280000 ) yMax = 400000;

    }

    return yMax;

};

export const getMinYValue = ( isPercent, minValue ) => {

    let yMin = 0;

    if ( isPercent ) {

        if ( minValue >= -8 && minValue < 0 ) yMin = -10;
        else if ( minValue >= -18 && minValue < -8 ) yMin = -20;
        else if ( minValue >= -28 && minValue < -18 ) yMin = -30;
        else if ( minValue >= -48 && minValue < -28 ) yMin = -60;
        else if ( minValue < -48 ) yMin = -100;

    }

    return yMin;

};
